import '../account/Drones.css';
import './ModemSettings.css';
import { useState, useEffect, useCallback, ReactNode } from 'react'
import { useTranslation } from "react-i18next";
import ModemMainP from "../account/ModemMainP";
import MainSettings from './settings/MainSettings';
import OGNSettings from './settings/OGNSettings';
import NebosvodSettings from './settings/NebosvodSettings';
import useDroneHubConnection from '../../hooks/DroneHubConnection';
import { ModemData } from '../../api/Drone';
import { HubSetOnlineMessage, HubSetOnlineSchema } from '../../asp/DroneHub';

type TabName = "settings" | "modem" | "ogn" | "nebosvod";

interface ModemSettingsProps {
    drone: ModemData;
    isNebosvodAuth: boolean;
    nebosvodAuthLogin: string;
    onNebosvodAuth: (login: string) => void;
    isAstra: boolean;
}

interface MenuButtonProps {
    tabName: TabName;
    activeImgSrc: string;
    inactiveImgSrc: string;
}

function ModemSettings({ drone, isNebosvodAuth, nebosvodAuthLogin, onNebosvodAuth, isAstra }: ModemSettingsProps): ReactNode {
    const { t } = useTranslation(['modem']);

    const droneHub = useDroneHubConnection();

    const [activeTab, setActiveTab] = useState<TabName>("settings");
    const [_isOnline, setIsOnline] = useState<boolean>(false);

    useEffect(() => {
        droneHub.connection.on('SetOnline', (message: HubSetOnlineMessage) => {
            const result = HubSetOnlineSchema.safeParse(message);
            if (result.success) {
                console.log("ModemSettings: SetOnline message received", result.data);
                setIsOnline(result.data.isOnline);
            } else {
                console.error(result.error);
            }
        });
    }, [droneHub]);

    useEffect(() => {
        setIsOnline(drone.isOnline)
    }, [drone]);

    const MenuButton = useCallback(({ tabName, activeImgSrc, inactiveImgSrc }: MenuButtonProps) => {
        return (
            <div className='menu-button' onClick={() => setActiveTab(tabName)}>
                <img className='menu-icon' src={activeTab === tabName ? activeImgSrc : inactiveImgSrc} alt="" />
            </div>
        )
    }, [activeTab]);

    return (
        <>
            <div className='modem-settings'>
                <div className='modem-settings-menu'>
                    <MenuButton
                        tabName="settings"
                        activeImgSrc="/image/menu/settings_on.svg"
                        inactiveImgSrc="/image/menu/settings.svg"
                    />
                    {/*<MenuButton 
                        tabName="modem" 
                        activeImgSrc="/image/menu/home_on.svg" 
                        inactiveImgSrc="/image/menu/home.svg"
                    />*/}
                    {!isAstra &&
                        <MenuButton
                            tabName="ogn"
                            activeImgSrc="/image/menu/ogn_on.svg"
                            inactiveImgSrc="/image/menu/ogn.svg"
                        />
                    }
                    {!isAstra &&
                        <MenuButton
                            tabName="nebosvod"
                            activeImgSrc="/image/menu/nebosvod_on.svg"
                            inactiveImgSrc="/image/menu/nebosvod.svg"
                        />
                    }
                </div>
                <div className='modem-settings-content'>
                    <div className='modem-settings-title'>
                        {activeTab === "modem" && t('main_page')}
                        {activeTab === "ogn" && "OGN/FlightRadar"}
                        {activeTab === "nebosvod" && "Небосвод"}
                        {activeTab === "settings" && t('settings')}
                    </div>
                    <div className='settings-tab'>
                        {activeTab === "settings" &&
                            <MainSettings drone={drone} isAstra={isAstra} />
                        }
                        {activeTab === "modem" &&
                            <ModemMainP drone={drone} />
                        }
                        {activeTab === "ogn" &&
                            <OGNSettings drone={drone} />
                        }
                        {activeTab === "nebosvod" &&
                            <NebosvodSettings
                                drone={drone}
                                isNebosvodAuth={isNebosvodAuth}
                                nebosvodAuthLogin={nebosvodAuthLogin}
                                onNebosvodAuth={onNebosvodAuth}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModemSettings;